exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-title{color:#ffc000;font-size:18px;padding-left:30px}.collapse-toggle{font-size:18px;padding-right:30px;cursor:pointer}@media(max-width: 767px){.collapse-title{padding-left:0}.collapse-toggle{padding-right:0;text-align:right}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/CollapseContainer/styles.scss
// module id = 644
// module chunks = 0